import { Provider } from "@angular/core";

export interface RestHttpConfigArgs {
  baseUrl: string;
}

export class RestHttpConfig implements RestHttpConfigArgs {
  baseUrl: string;

  constructor(config?: RestHttpConfigArgs) {
    if (config == null) {
      // TODO: error
      throw new Error("rest-http.config is invalid");
    }
    this.baseUrl = config.baseUrl;
  }
}

export function provideRestHttpConfig(config: RestHttpConfigArgs): Provider[] {
  return [
    {
      provide: RestHttpConfig,
      useValue: config
    }
  ];
}
